import { RemoteDeleteEvaluationCriteria } from 'data/usecases';
import { makeApiUrlEvaluationCriteria } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeleteEvaluationCriteria =
  (): RemoteDeleteEvaluationCriteria => {
    return new RemoteDeleteEvaluationCriteria(
      makeApiUrlEvaluationCriteria(),
      makeAxiosHttpClient(),
    );
  };
